import { PlayingState } from '@/scenarios/legacy-player/types/instance';

export enum SessionStopMode {
    StopScreen,
    JustPause,
}

export interface SessionStopWithScreenProps {
    contentId: string;
    playingState: PlayingState | undefined;
    play: () => void;
    pause: () => void;
    onIsSessionStoppedChanged?: (isSessionStopped: boolean) => void;
}

export interface SessionStopProps extends SessionStopWithScreenProps {
    mode: SessionStopMode;
}

export interface SessionStopImageProps {
    title?: string;
    posterUrl: string;
}

export interface SessionStopJustPauseProps {
    playingState: PlayingState | undefined;
    pause: () => void;
}
